import apiClient from "../authentication/utils/core/axios";

const NewsAPI = {
  fetchNews: async ({ ticker, tickers, sourceType, sort = "recency", skip = 0, limit = 20 } = {}) => {
    const response = await apiClient.get("/news", {
      params: { ticker, tickers, source_type: sourceType, sort, skip, limit },
    });
    return response.data;
  },

  fetchFollowedJournalists: async () => {
    const response = await apiClient.get("/news/followed-journalists");
    return response.data;
  },

  fetchArticle: async (articleId) => {
    const response = await apiClient.get(`/news/${articleId}`);
    return response.data;
  },

  fetchByTicker: async (symbol, limit = 10) => {
    const response = await apiClient.get(`/news/by-ticker/${symbol}`, { params: { limit } });
    return response.data;
  },

  submitArticle: async ({ title, bodyContent, tickerSymbols = [] }) => {
    const response = await apiClient.post("/news/submit", {
      title,
      body_content: bodyContent,
      ticker_symbols: tickerSymbols,
    });
    return response.data;
  },

  fetchModerationQueue: async ({ skip = 0, limit = 50 } = {}) => {
    const response = await apiClient.get("/news/moderation-queue", { params: { skip, limit } });
    return response.data;
  },

  decideModeration: async (articleId, { decision, reason }) => {
    const response = await apiClient.post(`/news/moderation-queue/${articleId}/decision`, {
      decision,
      reason,
    });
    return response.data;
  },
};

export default NewsAPI;
